import { fromJS } from 'immutable';
import { fetchPageContent } from '@client/connectivity/api.cms';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const COMMON_DATA_REDUCER_KEY = 'commonDataReducer';

const LOAD_COMMON_DATA = 'LOAD_COMMON_DATA';

let defaultState = fromJS({
  translations: {},
  hlfArticleListing: [],
  mainNavbarMenu: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_COMMON_DATA: {
      const { hlfArticleListing, mainNavbarMenu, ...rest } = action.payload;
      return state.merge({
        translations: fromJS(rest),
        hlfArticleListing: fromJS(_cleanHlfArticleListing(hlfArticleListing)),
        mainNavbarMenu: fromJS(_cleanHlfMainNavbarMenu(mainNavbarMenu)),
      });
    }
    default:
      return state;
  }
}

function _cleanHlfMainNavbarMenu(mainNavbarMenu) {
  try {
    return mainNavbarMenu.fields;
  } catch (error) {
    return {
      error: error && error.toString && error.toString(),
    };
  }
}

function _cleanHlfArticleListing(hlfArticleListing) {
  try {
    const articles = hlfArticleListing.fields.listing;

    const remappedArticles = articles.map((article) => {
      return article.fields;
    });

    return {
      title: hlfArticleListing.fields.title,
      listing: remappedArticles,
    };
  } catch (error) {
    return {
      error: error && error.toString && error.toString(),
    };
  }
}

export function loadCommonData() {
  return function (dispatch) {
    return fetchPageContent('commonData').then((response) => {
      return dispatch({
        type: LOAD_COMMON_DATA,
        payload: response,
      });
    });
  };
}

export const selectCommonDataTranslations = (state) => {
  return getIn(state[COMMON_DATA_REDUCER_KEY], 'translations');
};

export const selectHlfArticleListing = (state) => {
  return getIn(state[COMMON_DATA_REDUCER_KEY], 'hlfArticleListing');
};

export const selectHlfMainNavbarMenu = (state) => {
  return getIn(state[COMMON_DATA_REDUCER_KEY], 'mainNavbarMenu');
};
